<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YFXf4W/images/9781507203675.jpg?1712294946875" alt="This image is the cover for the book Music Theory 101, Adams 101"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Music Theory 101, Adams 101
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn the basics of music theory in this comprehensive and accessible guide.</b><br/><br/>From classical to hard rock, and jazz to hip hop, music is constantly evolving. But its fundamental principles remain largely unchanged. Understanding these basics is key to becoming a successful musician, composer, or well-rounded music lover. <i>Music Theory 101</i> covers everything novice musicians and lifelong learners need to know, including:<br/><br/>-How to read sheet music<br/><br/>-Understanding the construction of chords and scales<br/><br/>-The different rhythm and time signatures<br/><br/>-How keys are identified and organized<br/><br/>Full of music trivia, music history, comprehensive instruction, and visual aids of scales, music symbols, and chords, <i>Music Theory 101</i> is the essential guide you need for a crash course in music theory that even professional musicians would envy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Boone, Marc Schonbrun
      </h2>
      
      <p class="authorDescription body article">Brian Boone is an editor and writer for the bestselling Uncle John&rsquo;s Bathroom Reader line of trivia and humor books. He wrote <I>I Love Rock n&rsquo; Roll (Except When I Hate It)</I> and coauthored <I>American Inventions: Big Ideas That Changed Modern Life</I> and <I>How to Make Paper Airplanes</I>. He has contributed to How Stuff Works, Barnes &amp; Noble Reads, <I>McSweeney&rsquo;s</I>, Splitsider, Someecards, <I>The Onion</I>, Adult Swim, and <I>Funny or Die</I>. He lives in Oregon with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09e17d7b